var render = function () {
  var _vm$product, _vm$product$price$bon, _vm$product$price, _vm$product$price2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-price-block",
    class: [{
      'product-price-block_discount': !!_vm.discountAmount
    }]
  }, [!!_vm.discountAmount ? _c('div', {
    staticClass: "product-price-block__discount-marker"
  }, [_vm._v("\n    -" + _vm._s(_vm.discountAmount) + "%\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-price-block__wrapper"
  }, [!!((_vm$product = _vm.product) !== null && _vm$product !== void 0 && _vm$product.emptyPriceText) ? _c('div', {
    staticClass: "product-price-block__price-wrap product-price-block__price-wrap_empty"
  }, [_c('span', {
    staticClass: "product-price-block__price-wrap-text"
  }, [_vm._v(_vm._s(_vm.product.emptyPriceText))])]) : _vm.product.price ? _c('TSPrice', {
    staticClass: "my-9",
    attrs: {
      "price": _vm.product.price,
      "size": "big"
    }
  }) : _c('div', {
    staticClass: "product-price-block__price-wrap product-price-block__price-wrap_empty"
  }, [_c('span', {
    staticClass: "product-price-block__price-wrap-text"
  }, [_vm._v("Цена не указана")])]), _vm._v(" "), _vm.product.price && _vm.product.price.bonus || _vm.product.availableBonusPay === false ? _c('div', {
    staticClass: "product-price-block__bonus-count"
  }, [_c('TSBonusCount', {
    attrs: {
      "count": (_vm$product$price$bon = (_vm$product$price = _vm.product.price) === null || _vm$product$price === void 0 ? void 0 : _vm$product$price.bonus) !== null && _vm$product$price$bon !== void 0 ? _vm$product$price$bon : 0,
      "available-pay": _vm.product.availableBonusPay
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.offer && _vm.offer.length ? _c('ProductOfferList', {
    staticClass: "mt-12",
    attrs: {
      "list": _vm.offer,
      "path": _vm.pathWithoutID
    }
  }) : _vm._e(), _vm._v(" "), (_vm$product$price2 = _vm.product.price) !== null && _vm$product$price2 !== void 0 && _vm$product$price2.common || _vm.isPreOrder ? _c('div', {
    staticClass: "product-price-block__buttons mt-21"
  }, [_vm._t("button")], 2) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }